<template>
    <div ref="listWrap">
        <wrapper-list
                @edit="paasEidtPage"
                @delete="paasDeleteTableData"
                @detail="paasDetailPage"
                @calculate="paasCalculate"
                :isShowQuery ="false"
                ref="wrapperList" >
                <div slot="toolbar">
                    <Button icon="md-close" size = "24"  type="text" @click="goPack()"/>

                </div> 
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
           
          
        </wrapper-list>
    </div>
</template>

<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import CellBar from '@components/paas/cell-bar' //列表内操作
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import Express from "./express.vue"
    import {saveSendRecord,getOrderSend} from '@api/order';
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList,CellBar, EnumShow,Express},
        data() {
            return {
                serviceUrl:"/eb/order/send",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_orderCode:"",
                    query_EQ_orderId:this.$route.query.id,
                },
                order:{},
                paasData:[],
                isShow:false,
                index:0,
                defaultLabelWidth:200,
                addExpressModal:false,
                expressDetail:false,
                tableColumns:[
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(OrderExpand, {
                                props: {
                                    rowData: params.row
                                }
                            })
                        }
                    },
                    {
                        title: '订单号',
                        key: 'orderCode',
                        width:150,
                    },
                    {
                        title: '买家信息',
                        key: 'buyer',
                        "width": 160,
                        render:(h,params)=>{
                            var buyer = params.row.order.buyer?params.row.order.buyer:"无";
                            return h('div',[
                                h('p', {},"买家昵称："+buyer),
                                h('p', {},"收货人："+params.row.order.realName)
                            ])
                        }
                    },
                    {
                        title: '收货人手机',
                        key: 'userPhone',
                        render:(h,params)=>{
                            return h('div',params.row.order.userPhone)
                        },
                        width:125,
                    },
                    {
                        title: '详细地址',
                        key: 'userAddress',
                        render:(h,params)=>{
                            return h('div',params.row.order.userAddress)
                        },
                        width:200
                    },
                    {
                        title: '商品名称',
                        key: 'name',
                    },
                    {
                        title: '商品属性',
                        key: 'productAttr',
                    },
                    {
                        title: '数目',
                        key: 'purchaseNum',
                        render:(h,params)=>{
                            return h('div',params.row.purchaseNum)
                        },
                        width:100,
                    },
                    {
                        title: '支付时间',
                        key: 'payTime',
                        render:(h,params)=>{
                            return h('div',params.row.order.payTime)
                        },
                    },
                    {
                        title: '操作',
                        fixed: 'right',
                        render: (h, params) => {
                            let statusOperate = [];
                            let auditBtn = h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.order = params.row.order;
                                        this.addExpressModal = true;
                                        this.isShow = true;
                                    }
                                }
                            }, '发货');
                           
                            let detailBtn = h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        let that = this;
                                        that.getOrderSend(params.row.order.id);
                                        
                                        
                                    }
                                }
                            }, '已发货');
                            //待发货
                            if(params.row.sendType == "0"){
                                statusOperate.push(auditBtn);
                            }
                            //已发货
                            else if(params.row.sendType == "1"){
                                statusOperate.push(detailBtn);
                            }
                            return h('div',statusOperate);
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
          async  saveExpress(){
                let send = this.$refs.addExpress.paasFormData;
                send.orderCode = this.order.orderCode;
                send.orderId = this.order.id;
                let  {code,data} = await saveSendRecord(send);
                if(code===200){
                    this.queryTableDatas();
                    this.isShow = true;
                    this.$nextTick(()=>{
                      this.isShow = false;
                    })
                }

            },
            async getOrderSend(id){
                let  {code,data} = await getOrderSend(id);
                if(code===200){
                    this.paasData = data;
                    this.expressDetail = true;
                }
            },
            goPack(){
                

            }
        }
    }
</script>
